import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GenerateUsersComponent } from './generate-users.component';
import { BookAccessPackageDetailsComponent } from './book-access-package-details/book-access-package-details.component';
import { BookAccessPackageEditComponent } from './book-access-package-edit/book-access-package-edit.component';
import { BookAccessTicketSearchComponent } from './book-access-ticket-search/book-access-ticket-search.component';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { CheckboxModule } from 'primeng/checkbox';
import { CalendarModule } from 'primeng/calendar';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DialogModule } from 'primeng/dialog';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { TooltipModule } from 'primeng/tooltip';
import { FasServiceDynamicTableComponent } from 'fas-services';
import { QRCodeModule } from 'angularx-qrcode';
import { UserAccountLinkComponent } from '../../shared/components/user-account-link/user-account-link.component';

@NgModule({
  declarations: [
    GenerateUsersComponent,
    BookAccessPackageDetailsComponent,
    BookAccessPackageEditComponent,
    BookAccessTicketSearchComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
    InputNumberModule,
    CheckboxModule,
    CalendarModule,
    AutoCompleteModule,
    DialogModule,
    DynamicDialogModule,
    TooltipModule,
    FasServiceDynamicTableComponent,
    QRCodeModule,
    UserAccountLinkComponent,
  ],
  providers: [DialogService],
})
export class GenerateUsersModule {}
